import { Dialog } from '@cimplico/components';

type FYIJobChangeConfirmationProps = {
    onClose: () => void;
    onConfirm: () => void;
    mode: 'replacing' | 'removing';
};

function FYIJobChangeConfirmation({ onClose, onConfirm, mode }: FYIJobChangeConfirmationProps): JSX.Element {
    const description =
        mode === 'removing'
            ? 'Do you want to remove this FYI job? All files in the FYI folder will be removed. Any worksheets / other schedules using these files will become un-reviewed'
            : 'Do you want to replace this FYI job with another? All files from the old job in the FYI folder will be removed. Any worksheets / other schedules using these files will become un-reviewed';

    return (
        <Dialog
            title={`${mode === 'removing' ? 'Remove' : 'Change'} FYI Job`}
            description={description}
            onClose={onClose}
            onPrimaryActionClick={onConfirm}
            onSecondaryActionClick={onClose}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            isOpen
            type="error"
        />
    );
}

export default FYIJobChangeConfirmation;
